export class SolicitudModel {
    public idSolicitud: number;
    public idSocio: number;
    public idTipoSolicitud: number;
    public folioPago: string;
    public folio: string;
    public notaSocio: string;
    public estatus: string;
    public fechaSolicitud: string;
    public fechaAtencion: string;
    public idProducto: number;
    public solicitud: string;
    public descripcion: string;
    
    constructor() { }
}